import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, finalize, map } from "rxjs/operators";
import { Globals } from "../../app.globals";

@Injectable()
export class ClientService {
    constructor(private http: HttpClient, private globals: Globals) {}

    get(projectId?: number): Observable<Client> {
        this.globals.showSpinner();

        return this.http
            .get(this.getApiUrl() + (projectId ? "/" + projectId : ""))
            .pipe(
                map((res) => {
                    let result = res as Client;

                    return result;
                }),
                catchError(this.handleError),
                finalize(() => this.globals.hideSpinner())
            );
    }

    getAll(): Observable<Client[]> {
        this.globals.showSpinner();

        return this.http.get(this.getApiUrl() + "/getall").pipe(
            map((res) => {
                let result = res as Client[];

                return result;
            }),
            catchError(this.handleError),
            finalize(() => this.globals.hideSpinner())
        );
    }

    getApiUrl(): string {
        return "api/client";
    }

    handleError(error: Response): Observable<any> {
        return throwError(
            error || "Server error, please refresh and try again"
        );
    }
}

export class Client {
    name: string;
    base64Logo: string;
    logoUrl: string;
    secondaryColour: string;
    primaryColour: string;
    tertiaryColour: string;
    idleTime: number;
    timeout: number;
    currency: string;
}
